<template>
  <div class="question-zhihui">
    <div class="header-step">
      <el-steps :active="tab" class="steps-wrap">
        <el-step :title="$t('open.t1')">
          <div class="icon-box" slot="icon" @click="selectTab(0)">
            <el-image class="insert-icon" v-if="tab == 0"
              :src="require('@/assets/images/personal-icon.png')"></el-image>
            <el-image class="insert-icon" v-else-if="tab > 0"
              :src="require('@/assets/images/pay-success.png')"></el-image>
          </div>
        </el-step>
        <el-step :title="$t('open.t2')">
          <div class="icon-box" slot="icon" @click="selectTab(1)">
            <el-image v-if="tab == 1" class="insert-icon" :src="require('@/assets/images/quest-int.png')"></el-image>
            <el-image v-else-if="tab < 1" class="insert-icon" :src="require('@/assets/images/quest.png')"></el-image>
            <el-image class="insert-icon" v-else :src="require('@/assets/images/pay-success.png')"></el-image>
          </div>
        </el-step>

      </el-steps>
    </div>
    <div class="content-step">
      <personal-zhihui :formData="formData" @resetFormData="resetFormData" :step="tab" @nextStep="nextStep"
        @prevStep="prevStep" :type="type" v-if="tab == 0"></personal-zhihui>
      <more-info-zhihui :formData="formData" @resetFormData="resetFormData" :step="tab" @nextStep="nextStep"
        @prevStep="prevStep" :type="type" v-else-if="tab == 1"></more-info-zhihui>
    </div>
  </div>
</template>

<script>
import PersonalZhihui from './Personal'
import MoreInfoZhihui from './MoreInfo'

export default {
  name: 'QuestionZhihui',
  data () {
    return {
      tab: 0,
    }
  },
  components: {
    PersonalZhihui,
    MoreInfoZhihui,
  },
  props: {
    dataType: {
      type: String,
      default: () => ""
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    cancelEdit: {
      type: Function,
      default: () => { }
    },
    type: {
      type: String,
      default: () => ""
    }
  },
  mounted () {
    const that = this
    setTimeout(() => {
      console.log(that.formData, that);
    }, 2000)
  },
  watch: {},
  methods: {
    selectTab (index) {

      this.tab = Math.min(index, this.tab);
    },
    nextStep () {
      this.tab++;
    },
    prevStep () {
      this.tab--;
    },
    resetFormData () {
      console.log("QuestionZhihui resetFormData");
      this.$emit('resetFormData')
    }
  }
}
</script>

<style scoped>
.header-step>>>.el-step__icon {
  border: none;
}
</style>

<style lang="scss" scoped>
.question-zhihui {
  position: relative;
  width: 100%;

  .header-step {
    position: relative;
    padding: 20px 20%;


    .el-step__icon {
      border: none;
    }
  }

  .content-step {
    position: relative;
    padding: 10px;
  }
}
</style>